var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play_circle_black_24dp",
    transform: "translate(0.018)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1987",
    "data-name": "Group 1987"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3319",
    "data-name": "Rectangle 3319",
    transform: "translate(-0.018)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1988",
    "data-name": "Group 1988",
    transform: "translate(2.685 2.685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8322",
    "data-name": "Path 8322",
    d: "M15.424,2A13.424,13.424,0,1,0,28.847,15.424,13.428,13.428,0,0,0,15.424,2ZM12.068,21.464V9.383l9.4,6.041Z",
    transform: "translate(0 0)",
    fill: "#008001"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.8118d139ca121d5dd1bd07d9a47543ec.svg";
export { ForwardRef as ReactComponent };